module.exports = __webpack_public_path__ + "img/microphone.jpg.9bc577d8.webp";